export default __webpack_public_path__ + "static/1893-c2bfefeaca06ecb0e492f4f6e38a28f8.gif";